module.exports = __webpack_public_path__ + "img/d979f727cb155bd10085faec555a4d0b.png";